import { tokens } from '@hotjar/hotsauce';

export const SIDEBAR_WIDTH = 230;

export const SMART_PANEL_EXPANDED_WIDTH = 320;

export const SMART_PANEL_COLLAPSED_WIDTH = 64;

export const STATUSBAR_HEIGHT = 50;

export const SHORT_LINK_WIDGET_HEIGHT = tokens.spacer.x8;

export const OPTIONS_WIDGET_HEIGHT = tokens.spacer.x5;

export const CONTENT_RIGHT_LEFT_PADDING = tokens.spacer.x5;

export const CONTENT_TOP_PADDING = tokens.spacer.x4;

export const SMART_PANEL_SPACING = tokens.spacer.x3;

export const MAGIC_RULER_WIDTH = tokens.spacer.x3;
